function FleetListGridletController(
  userService,
  CommonService,
  fleetService,
  $state,
  $interval,
  $timeout
) {
  const ctrl = this;
  const tryCatch = CommonService.tryCatch;
  const setSelectedTrain = CommonService.setSelectedTrain;

  ctrl.$onInit = async () => {
    ctrl.searchString = undefined;
    ctrl.loadedTrains = [];
    ctrl.trains = [];
    updateTrains(await ctrl.fetchFleetInfo());
    ctrl.contentAreaId = 'div#fleetListScrollContainer';
    ctrl.area = '#gridletContentArea-fleet-list-gridlet';
    ctrl.sortType = 'trainId';
    ctrl.sortReverse = false;
    ctrl.dataLoading = false;
    ctrl.smallFont = false;
    ctrl.loadBusy = false;
    ctrl.customMelco = __env.profile === 'MELCO';
    ctrl.hasFleetInfoRead = userService.hasFleetInfoRead();
    if (ctrl.hasFleetInfoRead) {
      ctrl.fetchFleetInfo();
      startPoll();
    }
    ctrl.initialized = true;
  };

  ctrl.$onChanges = changes => {
    if (changes.settings && ctrl.initialized) {
      $timeout(async () => {
        adjustContentSize(ctrl.area, ctrl.contentAreaId);
        updateTrains(await ctrl.fetchFleetInfo());
      }, 200);
    }
  };

  ctrl.$onDestroy = () => {
    $interval.cancel(ctrl.dataFetchPromise);
  };

  ctrl.sorter = (v1, v2) => {
    if (ctrl.sortType === 'speed' || ctrl.sortType === 'status' || ctrl.sortType === 'stationFull' || ctrl.sortType === 'nextStationFull' ||
      ctrl.sortType === 'destinationStationFull' || ctrl.sortType === 'dataReceived' || ctrl.sortType === 'trainClock' || v1.type === 'number') {
      // Easy access the values being compared - or fallback to zero, if property not available
      const value1 = (typeof v1.value.status !== 'undefined') ? v1.value.status[ctrl.sortType] : 0;
      const value2 = (typeof v2.value.status !== 'undefined') ? v2.value.status[ctrl.sortType] : 0;

      // https://docs.angularjs.org/api/ng/filter/orderBy
      //  0  if the values are equal (by strict equality comparison, i.e. using ===)
      // -1  if the 1st value is "less than" the 2nd value (compared using the < operator)
      //  1  otherwise
      let result = 1;
      if (value1 === value2) {
        result = 0;
      } else if (value1 < value2) {
        result = -1;
      }
      return ctrl.sortType === 'status' ? -result : result;
    } else {
      // If either value is object, compare their indices instead
      if (v1.type !== 'string' || v2.type !== 'string') {
        return (v1.index < v2.index) ? -1 : 1;
      }

      // Compare strings alphabetically, taking locale into account
      return v1.localeCompare(v2);
    }
  };

  const adjustContentSize = (selectorId, contentAreaSelectorId) => {
    $timeout(function () {
      const selectorIdHeight = $(selectorId).height();
      if (selectorIdHeight > 100 && !ctrl.settings.fullscreen) {
        $(contentAreaSelectorId).height(selectorIdHeight - 50);
      } else if (ctrl.settings.fullscreen) {
        $(contentAreaSelectorId).height(selectorIdHeight - 93);
      }
      ctrl.areaWidth = $(contentAreaSelectorId).width();
      // If adjust is fired when resize event is going on, size is incorrectly set to 100
      if (ctrl.areaWidth === 100) {
        ctrl.smallFont = false;
      } else {
        ctrl.smallFont = ctrl.areaWidth < 580;
      }
    }, 200);
  };

  // Triggered with 500ms debounce each time
  // user types something in search filter field
  ctrl.searchChange = async () => {
    if (ctrl.hasFleetInfoRead) {
      updateTrains(await ctrl.fetchFleetInfo());
    } else {
      updateTrains(ctrl.loadedTrains);
    }
  };

  ctrl.setSortType = async column => {
    ctrl.sortReverse = (ctrl.sortType === column) ? !ctrl.sortReverse : false;
    ctrl.sortType = column;
    updateTrains(await ctrl.fetchFleetInfo());
  };

  const startPoll = () => {
    if (!ctrl.dataFetchPromise) {
      ctrl.lastLoad = DateTime.now();
      ctrl.dataFetchPromise = $interval(triggerFetchLoad, 5000);
    }
  };

  const updateTrains = (trains) => {
    ctrl.loadedTrains = trains;
    ctrl.trains = filterTrains(ctrl.loadedTrains);
  };

  const filterTrains = (trains) => {
    if (!ctrl.searchString) {
      return trains;
    } else {
      return trains.filter(getTrainFilter());
    }
  };

  const getTrainFilter = () => {
    return train => !ctrl.searchString || !train || !train.status ||
      train.status.trainId && train.status.trainId.toLowerCase().includes(ctrl.searchString.toLowerCase()) ||
      train.status.train && train.status.train.toLowerCase().includes(ctrl.searchString.toLowerCase()) ||
      train.status.station && train.status.station.toLowerCase().includes(ctrl.searchString.toLowerCase()) ||
      train.status.stationFull && train.status.stationFull.toLowerCase().includes(ctrl.searchString.toLowerCase()) ||
      train.status.nextStation && train.status.nextStation.toLowerCase().includes(ctrl.searchString.toLowerCase()) ||
      train.status.nextStationFull && train.status.nextStationFull.toLowerCase().includes(ctrl.searchString.toLowerCase()) ||
      train.status.destinationStation && train.status.destinationStation.toLowerCase().includes(ctrl.searchString.toLowerCase()) ||
      train.status.destinationStationFull && train.status.destinationStationFull.toLowerCase().includes(ctrl.searchString.toLowerCase());
  };

  const triggerFetchLoad = async () => {
    if (ctrl.lastLoad.diffNow('seconds').seconds < -5) {
      updateTrains(await ctrl.fetchFleetInfo());
    }
  };

  // Fetch list of trains, wrapped in tryCatch, returns data if no error.
  ctrl.fetchFleetInfo = () => {
    return tryCatch(async () => await fleetService.getSignOn())
      .fold(e => {
          console.error(`Fleet fetch error: ${e}`);
          return e;
        },
        data => data);
  };

  ctrl.goToTrainPage = train => {
    setSelectedTrain(train);
    $state.go('train', {consist: train.status.trainId});
  };

  ctrl.scrollElementTop = element => {
    if (element) {
      $(element).animate({scrollTop: 0}, 'fast');
    }
  };
}

angular
  .module('gridlets.module')
  .controller('FleetListGridletController', FleetListGridletController);
